import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { listAdminPosts, savePost } from "@/lib/posts.functions";
import { PostEditorWorkspace } from "@/components/admin-workspace/PostEditorWorkspace";
import type { ListRow } from "@/components/admin-workspace/model";

export const Route = createFileRoute("/admin/yazi/yeni")({
  head: () => ({ meta: [{ title: "Yeni yazı · Yönetim" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: Page,
});

function Page() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const list = useServerFn(listAdminPosts);
  const save = useServerFn(savePost);
  const { data: all } = useQuery({ queryKey: ["admin-posts"], queryFn: () => list() });
  return (
    <PostEditorWorkspace
      allPosts={(all?.posts ?? []) as ListRow[]}
      onBack={() => navigate({ to: "/admin/icerik" })}
      onCreated={(id) => navigate({ to: "/admin/yazi/$id", params: { id }, replace: true, ignoreBlocker: true })}
      onSave={async (p) => {
        const { published_at: _ignored, ...payload } = p;
        const r = await save({ data: payload });
        void qc.invalidateQueries({ queryKey: ["admin-posts"] });
        return r;
      }}
    />
  );
}
